"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const RichTextComponent_1 = __importDefault(require("../../richtext/RichTextComponent"));
const ExprInsertModalComponent_1 = __importDefault(require("./ExprInsertModalComponent"));
const ExprUpdateModalComponent_1 = __importDefault(require("./ExprUpdateModalComponent"));
const ExprItemsHtmlConverter_1 = __importDefault(require("../../richtext/ExprItemsHtmlConverter"));
const expressions_ui_1 = require("@mwater/expressions-ui");
/**
 * Text component which is provided with the data it needs, rather than loading it.
 * Used by TextWidgetComponent and also by other components that embed text fields
 */
class TextComponent extends react_1.default.Component {
    static contextType = expressions_ui_1.LocaleContext;
    exprInsertModal = null;
    exprUpdateModal = null;
    editor = null;
    createItemsHtmlConverter() {
        return new ExprItemsHtmlConverter_1.default(this.props.schema, this.props.onDesignChange != null, this.props.exprValues, 
        // Display summaries if in design mode and singleRowTable is set
        this.props.onDesignChange != null && this.props.singleRowTable != null, 
        // Only replace named strings if not editing
        this.props.onDesignChange == null ? this.props.namedStrings : undefined, this.context);
    }
    handleItemsChange = (items) => {
        const design = { ...this.props.design, items };
        return this.props.onDesignChange(design);
    };
    handleInsertExpr = (item) => {
        const html = '<div data-embed="' + lodash_1.default.escape(JSON.stringify(item)) + '"></div>';
        return this.editor.pasteHTML(html);
    };
    replaceItem(item) {
        var replaceItemInItems = (items, item) => lodash_1.default.map(items, function (i) {
            if (i.id === item.id) {
                return item;
            }
            else if (i.items) {
                return lodash_1.default.extend({}, i, { items: replaceItemInItems(i.items, item) });
            }
            else {
                return i;
            }
        });
        const items = replaceItemInItems(this.props.design.items || [], item);
        this.props.onDesignChange({ ...this.props.design, items });
    }
    handleItemClick = (item) => {
        this.exprUpdateModal.open(item, (item) => {
            // Replace in items
            this.replaceItem(item);
        });
    };
    handleAddExpr = (ev) => {
        ev.preventDefault();
        this.exprInsertModal.open();
    };
    renderExtraPaletteButtons() {
        return (react_1.default.createElement("div", { key: "expr", className: "mwater-visualization-text-palette-item", onMouseDown: this.handleAddExpr },
            react_1.default.createElement("i", { className: "fa fa-plus" }),
            " ",
            T `Expression`));
    }
    renderModals() {
        return [
            react_1.default.createElement(ExprInsertModalComponent_1.default, { key: "exprInsertModal", ref: (c) => {
                    this.exprInsertModal = c;
                }, schema: this.props.schema, dataSource: this.props.dataSource, onInsert: this.handleInsertExpr, singleRowTable: this.props.singleRowTable }),
            react_1.default.createElement(ExprUpdateModalComponent_1.default, { key: "exprUpdateModal", ref: (c) => {
                    this.exprUpdateModal = c;
                }, schema: this.props.schema, dataSource: this.props.dataSource, singleRowTable: this.props.singleRowTable })
        ];
    }
    refRichTextComponent = (c) => {
        this.editor = c;
    };
    render() {
        const style = {
            position: "relative",
            width: this.props.width,
            height: this.props.height
        };
        return (react_1.default.createElement("div", null,
            this.renderModals(),
            react_1.default.createElement(RichTextComponent_1.default, { ref: this.refRichTextComponent, className: `mwater-visualization-text-widget-style-${this.props.design.style || "default"}`, style: style, items: this.props.design.items, onItemsChange: this.props.onDesignChange ? this.handleItemsChange : undefined, onItemClick: this.handleItemClick, itemsHtmlConverter: this.createItemsHtmlConverter(), includeHeadings: this.props.design.style === "default" || !this.props.design.style, extraPaletteButtons: this.renderExtraPaletteButtons() })));
    }
}
exports.default = TextComponent;
